import React, { useContext } from 'react';
import PracticePeriodPill from '../components/pill';
import { CalendarPsaContext } from './calendarPsaContext';
import {
  PraksisaktivitetStatusDto,
  PraksiskalenderAktivitetDto,
} from '../api/generated/praksissted-generated-api';
import { NavLink } from 'react-router-dom';
import { formatIsoTzLess, getWeekDay, WeekYear } from '../date.utils';
import { practicePeriodColorClass } from './calendarModels';
import translation from '../practiceactivity/calendarCell.psa.i18n';
import { useFormatMessageFor } from '../i18n/translation';

const useStatusLabel = (
  status: PraksisaktivitetStatusDto | undefined,
): string => {
  const labels = useFormatMessageFor(translation);

  switch (status) {
    case PraksisaktivitetStatusDto.KanBekreftes:
      return labels.kanBekreftes;
    case PraksisaktivitetStatusDto.BekreftetMenManglerKapasitet:
      return labels.bekreftetMenManglerKapasitet;
    case PraksisaktivitetStatusDto.BekreftetOverstyrtKapasitet:
      return labels.bekreftetOgHarKapasitet;
    case PraksisaktivitetStatusDto.BekreftetOgHarKapasitet:
      return labels.bekreftetOgHarKapasitet;
    case PraksisaktivitetStatusDto.BekreftetMenManglerFordeling:
      return labels.bekreftetMenManglerFordeling;
    case PraksisaktivitetStatusDto.KlarForGjennomfoering:
      return labels.klarForGjennomfoering;
    case PraksisaktivitetStatusDto.Gjennomfoert:
      return labels.gjennomfoert;
    case PraksisaktivitetStatusDto.Avtalefeil:
      return labels.avtalefeil;
    case undefined:
      return '';
  }
};

interface CellProps {
  weekYear: WeekYear;
  mouseIn: Function;
  mouseOut: Function;
  practicePeriod: PraksiskalenderAktivitetDto | null;
}

const CalendarCell = ({
  weekYear,
  mouseIn,
  mouseOut,
  practicePeriod,
}: CellProps) => (
  <td
    onMouseEnter={() => mouseIn(weekYear)}
    onMouseLeave={() => mouseOut(null)}
    className={practicePeriod ? 'pill-wrapper' : ''}
  >
    {practicePeriod && (
      <PracticePeriodPillWrapper practicePeriod={practicePeriod} />
    )}
  </td>
);

interface PracticePeriodPillWrapperProps {
  practicePeriod: PraksiskalenderAktivitetDto;
}

const PracticePeriodPillWrapper = ({
  practicePeriod,
}: PracticePeriodPillWrapperProps) => {
  const statusLabel = useStatusLabel(practicePeriod.status);
  const { weekNumbers, earliestVisibleIsoDate, isWeekly } =
    useContext(CalendarPsaContext);
  const lastRenderedDate =
    weekNumbers.length > 0
      ? formatIsoTzLess(getWeekDay(weekNumbers[weekNumbers.length - 1], 6))
      : '';

  return (
    <NavLink to={'/calendar/activity/' + practicePeriod.id}>
      <PracticePeriodPill
        tooltipText={statusLabel}
        colorPatternClass={practicePeriodColorClass(practicePeriod)}
        practicePeriod={practicePeriod}
        onClick={() => {}}
        pxPerDayScale={isWeekly ? 34 / 7.0 : 21}
        extraClasses={isWeekly ? ['weekly'] : ['daily']}
        isWeekly={isWeekly}
        earliestVisibleIsoDate={earliestVisibleIsoDate}
        latestVisibleIsoDate={lastRenderedDate}
      />
    </NavLink>
  );
};

export default CalendarCell;
